export default "__VITE_ASSET__BaRQFfKN__"